import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../components/PageTitle";

declare const __BUILD_ID__: string;

export default function About() {
  const navigate = useNavigate();
  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="text-sm text-slate-400">← Back</button>
        <PageTitle>About</PageTitle>
      </div>

      <section className="p-4 rounded-2xl bg-slate-900 border border-slate-800 space-y-2">
        <div className="text-xs text-slate-400 uppercase tracking-wide">How the AI estimates work</div>
        <p className="text-sm text-slate-300 leading-relaxed">
          When you photograph a meal or describe one in words, the image or text is sent to a
          modern vision/language model trained to identify foods and estimate portion sizes
          and macros. The model returns its best guess as structured nutrition data.
        </p>
        <p className="text-sm text-slate-300 leading-relaxed">
          Realistic accuracy is <span className="font-semibold text-slate-100">±10–20%</span> when portions
          are clearly visible (measuring cups, standard plates) and worse when food is obscured, mixed,
          or you ate something unusual. Treat estimates as a starting point — every field on the review
          screen is editable so you can correct anything the AI got wrong.
        </p>
      </section>

      <section className="p-4 rounded-2xl bg-slate-900 border border-slate-800 space-y-2">
        <div className="text-xs text-slate-400 uppercase tracking-wide">When to trust vs. adjust</div>
        <ul className="text-sm text-slate-300 leading-relaxed list-disc pl-5 space-y-1">
          <li><span className="text-slate-100">Trust:</span> branded products via barcode (real label data) and curated generic foods (standard reference values).</li>
          <li><span className="text-slate-100">Cross-check:</span> AI photo estimates — adjust the quantity if your portion was bigger or smaller than the AI guessed.</li>
          <li><span className="text-slate-100">Override:</span> homemade or restaurant meals where you know the ingredients better than the AI does. Edit the macro fields directly.</li>
        </ul>
      </section>

      <section className="p-4 rounded-2xl bg-slate-900 border border-slate-800 space-y-2">
        <div className="text-xs text-slate-400 uppercase tracking-wide">Your data & privacy</div>
        <p className="text-sm text-slate-300 leading-relaxed">
          Your meals, weights, goals, and water entries are stored privately under your account. Meal
          photos use signed URLs that expire after an hour. No ads, no third-party analytics, no
          marketing emails.
        </p>
        <p className="text-sm text-slate-300 leading-relaxed">
          Download everything as JSON from Settings anytime. Delete your account in two taps — every
          row and every photo is removed.
        </p>
        <p className="text-sm text-slate-300">
          Full disclosure of how data is processed:{" "}
          <Link to="/legal" className="text-emerald-400 underline">Privacy Policy</Link>.
        </p>
      </section>

      <section className="p-4 rounded-2xl bg-slate-900 border border-slate-800 space-y-2">
        <div className="text-xs text-slate-400 uppercase tracking-wide">Credits</div>
        <ul className="text-xs text-slate-400 leading-relaxed space-y-1">
          <li>Branded food database: <a href="https://world.openfoodfacts.org" className="underline" target="_blank" rel="noopener noreferrer">Open Food Facts</a> (open data, community-edited)</li>
          <li>Generic food macros: USDA FoodData Central reference values</li>
        </ul>
      </section>

      <div className="text-[10px] text-slate-600 text-center pt-2">
        Build {__BUILD_ID__}
      </div>
    </div>
  );
}
